import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';

import { handleErrorResponse } from '../../utils/handleError';
import {
  IDownloadInvoiceVariables,
  postDownloadInvoice,
  IDownloadReceiptVariables,
  postDownloadReceipt,
} from '../../apis/invoice';

export const useDownloadInvoice = () => {
  const { isPending, data, mutateAsync } = useMutation({
    mutationKey: ['downloadInvoice'],
    mutationFn: postDownloadInvoice,
    onError: (error) => handleErrorResponse(error, 'Download Invoice'),
  });

  const downloadInvoice = useCallback(
    async (variables: IDownloadInvoiceVariables) => {
      return await mutateAsync(variables);
    },
    [mutateAsync]
  );

  return {
    isInvoiceGenerating: isPending,
    pdfData: data,
    downloadInvoice,
  };
};

export const useDownloadReceipt = () => {
  const { isPending, data, mutateAsync, isError } = useMutation({
    mutationKey: ['downloadReceipt'],
    mutationFn: postDownloadReceipt,
    onError: (error) => handleErrorResponse(error, 'Download Receipt'),
  });

  const downloadReceipt = useCallback(
    async (variables: IDownloadReceiptVariables) => {
      return await mutateAsync(variables);
    },
    [mutateAsync]
  );

  return {
    isError,
    isReceiptGenerating: isPending,
    receiptData: data,
    downloadReceipt,
  };
};
